<div class="container my-5">
    <h1>{{app}}</h1>
    <form [formGroup]="loginForm" (ngSubmit)="loginNow($event)">
        <div class="form-group">
          <label for="exampleInputEmail1">Adresse électronique</label>
          <input type="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" formControlName="login">
          <small id="emailHelp" class="form-text text-muted">Nous ne partagerons jamais votre e-mail avec quelqu'un d'autre.</small>
        </div>
        <div class="form-group">
          <label for="exampleInputPassword1">Mot de passe</label>
          <input type="password" class="form-control" id="exampleInputPassword1"  formControlName="password">
        </div>
        
        <p *ngIf=" isLoading">  <strong>Essayer de se connecter aux serveurs...</strong></p>
        <button *ngIf="! isLoading" type="submit" class="btn btn-primary" [disabled]="! loginForm.valid">S'IDENTIFIER</button><br/><br/><br/>
        
        <div class="alert alert-danger" *ngIf="errorMessage!=''">{{errorMessage}}</div>

        <a routerLink="/about">À propos des développeurs d'applications.</a>
    </form>

</div>